import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * EmployeeSidebar
 * Componente que renderiza a lista de Colaboradores no painel lateral do layout Master-Detail.
 * Migrado para o NeoSideMenu do Neo Design System.
 */
const EmployeeSidebar = ({
    employees = [],
    roles = [],
    activeId,
    onSelect,
    onCreateNew,
    loading
}) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Auxiliar para obter o nome do cargo (role)
    const getRoleName = (employee) => {
        if (employee.role === 'admin') return 'Administrador';
        if (employee.role === 'owner') return 'Dono / Sócio';
        const roleObj = roles?.find(r => r.id === employee.role);
        // Fallback pro nome salvo caso os roles demorem ou sumam
        return roleObj ? roleObj.name : (employee.roleName || "Cargo Vazio");
    };

    // Filtrar colaboradores baseado na pesquisa local
    const filteredEmployees = employees.filter((employee) => {
        const name = employee.fullName || `${employee.firstName || ""} ${employee.lastName || ""}`.trim() || employee.email || "";
        return name.toLowerCase().includes(searchQuery.toLowerCase());
    });

    // Mapear colaboradores para o formato padrão do NeoSideMenu
    const sideMenuItems = filteredEmployees.map((employee) => {
        const label = employee.fullName || `${employee.firstName || ""} ${employee.lastName || ""}`.trim() || employee.email || "Colaborador";
        
        let badge = null;
        let badgeVariant = null;
        if (employee.status === 'suspended') {
            badge = "Suspenso";
            badgeVariant = "warning";
        } else if (employee.status !== GLOBAL_STATUS.ACTIVE) {
            badge = "Inativo";
            badgeVariant = "muted";
        }

        return {
            id: employee.id,
            label: label,
            description: getRoleName(employee),
            photoUrl: employee.photoUrl || null,
            icon: "mdi-account-outline",
            badge,
            badgeVariant
        };
    });

    return (
        <NeoSideMenu
            title="Colaboradores"
            subtitle={`${employees.length} cadastrados`}
            icon="mdi-account-group-outline"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const emp = employees.find((e) => e.id === id);
                if (emp) onSelect(emp);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar colaborador..."
                />
            }
        />
    );
};

EmployeeSidebar.propTypes = {
    employees: PropTypes.array.isRequired,
    roles: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default EmployeeSidebar;
